import * as React from 'react';

import * as Highlight from 'react-highlighter';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { LocalizedToggle } from 'components/common/localized-toggle';
import { AnswerViewModel, UserQuestionViewModel } from 'models';

export type QuestionAnswerLocalizedProps = QuestionAnswerProps & LocalizedComponentProps;

export interface QuestionAnswerProps {
  index: number;
  question: UserQuestionViewModel;
  searchString: string;
}

@withLocalization
export class QuestionAnswer extends React.Component<QuestionAnswerLocalizedProps> {
  public render() {
    const { index, l10n, question, searchString } = this.props;
    const { answers, questionText, questionSubmissionTime, questionId } = question;

    return (
      <article key={`question-card-${index}`} id={questionId} className="question-card uitk-card-separator-bottom all-t-padding-six">
        <section className="review-byline">
          <div className="pwa-theme--grey-700 uitk-type-heading-300">
            <Highlight search={searchString}>{questionText}</Highlight>
          </div>
        </section>

        {answers &&
          answers.length > 0 && (
            <React.Fragment>
              {answers.map(answer => (
                <Answer
                  answer={answer}
                  key={answer.answerId}
                  searchString={searchString}
                  questionSubmissionTime={questionSubmissionTime}
                  l10n={l10n}
                />
              ))}
            </React.Fragment>
          )}
      </article>
    );
  }
}

interface AnswerProps extends LocalizedComponentProps {
  answer: AnswerViewModel;
  searchString: string;
  questionSubmissionTime: string;
}

export const Answer: React.FunctionComponent<AnswerProps> = ({ answer, searchString, questionSubmissionTime, l10n }) => (
  <section className="review-cards all-t-padding-two">
    <span className="answer-meta-date uitk-type-300 pwa-theme--grey-600">
      {questionSubmissionTime ? l10n.formatDateString(questionSubmissionTime, { skeleton: 'yMMMd' }) : ''}
    </span>
    <article key={`answer-card-${answer.answerId}`} id={answer.answerId} className="answer-card all-b-padding-three all-t-padding-zero">
      <section className="mgr-responses uitk-type-200 pwa-theme--grey-600 all-l-margin-six all-t-margin-three all-b-margin-two">
        <div id={`id-${answer.answerId}`} key={answer.answerId} className="mgr-response">
          <AnswerText answerText={answer.answerText} searchString={searchString} />
          <AnswerAuthor userDisplayName={answer.userDisplayName} />
        </div>
      </section>
    </article>
  </section>
);
Answer.displayName = 'Answer';

interface AnswerTextProps {
  answerText: string;
  searchString: string;
}

export const AnswerText: React.FunctionComponent<AnswerTextProps> = ({ answerText, searchString }) => (
  <LocalizedToggle className="reviews-toggle">
    <span className="uitk-type-200 pwa-theme--grey-700">
      <Highlight search={searchString}>{answerText}</Highlight>
    </span>
  </LocalizedToggle>
);
AnswerText.displayName = 'AnswerText';

interface AnswerAuthorProps {
  userDisplayName?: string;
}

export const AnswerAuthor: React.FunctionComponent<AnswerAuthorProps> = ({ userDisplayName }) =>
  userDisplayName && (
    <span className="uitk-type-bold pwa-theme--grey-700">
      <div className="all-y-padding-two">{userDisplayName}</div>
    </span>
  );
AnswerAuthor.displayName = 'AnswerAuthor';
